import { generateUuid } from '~/assets/javascript/utils/string/uuid';

export const buildBaseInfoComponent = () => ({
  id: generateUuid(),
});
